// logo slider

$('.logo-slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    loop:true,

    // autoplaySpeed: 0,
	// speed: 9000,
	// pauseOnHover: false,
	// cssEase: 'linear',

    autoplaySpeed: 1000,
    speed: 9000,
    pauseOnHover:true,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 2
            }
        }
        ,{
            breakpoint: 424,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 374,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$('.logo-slider-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    loop:true,

    // autoplaySpeed: 0,
	// speed: 9000,
	// pauseOnHover: false,
	// cssEase: 'linear',

    autoplaySpeed: 2000,
    speed: 2000,
    pauseOnHover:true,
    responsive: [
       {
            breakpoint: 424,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 374,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

